import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Arme les animations au scroll : sans cette classe, le CSS laisse
// tout visible (aucun contenu ne peut disparaître si le JS casse).
document.documentElement.classList.add("js-anim");

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
